import React, { useState, useEffect } from 'react';
import Tools from '../../Tools';
import Popover from '../../ui/Popover';
import IconView from '../../icons/IconView';

const DocsRipley = (props) => {

    const [selectedAllDocs, setSelectedAllDocs] = useState(true);
    const [loading, setLoading] = useState({ client: false, campaign: false, tasks: false, documents: false, patent: false });
    const [error, setError] = useState(false);
    const [documentId, setDocumentId] = useState(null);
    const [currentRow, setCurrentRow] = useState(-1);

    const toggleAllDebts = () => {
        setSelectedAllDocs(!selectedAllDocs); //variable to toggle
        if (selectedAllDocs) {
            props.documents.forEach(d => { d.selected = false; });
            props.setDebtFn(0);
        } else {
            props.documents.forEach(d => { d.selected = true; });
            props.setDebtFn(props.documents.reduce((a, doc) => { return a + Number(doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)); }, 0));
        }
    }

    const selectDebt = (event, doc) => {
        if (!event.target.checked) {
            doc.selected = false;
            props.setDebtFn(props.debt - Number(event.target.value));
        } else {
            doc.selected = true;
            props.setDebtFn(props.debt + Number(event.target.value));
        }
    }

    useEffect(() => {
        //const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.saldo_pend - ((doc.dscto / 100) * doc.saldo_pend)); }, 0);
        const totalDebt = props.documents.reduce((a, doc) => { return a + Number(doc.saldo_contable); }, 0);
        props.setDebtFn(totalDebt);
    }, [props.documents]);

    return (
        <table className="fullWidth">
            <thead>
                <tr>
                    <th><input type="checkbox" onChange={toggleAllDebts} defaultChecked={true} /> &nbsp; CEDENTE</th>
                    <th className='center'>Operación</th>
                    <th className='center'>Apertura</th>
                    <th className='center'>Castigo</th>
                    <th className='center'>Score</th>
                    <th className='right'>Saldo generado</th>
                    <th className='center'>DESC. PUT</th>
                    <th className='center'>Tipo Oferta</th>
                    <th className='right'>Saldo Final</th>
                </tr>
            </thead>
            <tbody>
                {props.documents.map((doc, index) => {
                    return (
                        <tr key={index}>
                            <td>
                                <label className="forCheckbox">
                                    <input type="checkbox" name={'ckeck' + index} value={doc.saldo_contable} onChange={(e) => selectDebt(e, doc)} checked={doc.selected} defaultChecked={true} />
                                    Ripley castigo
                                </label>
                            </td>
                            <td className="center">{doc.num_documento}</td>
                            <td className="center">{doc.fecha_apertura}</td>
                            <td className="center">{doc.fecha_castigo}</td>
                            <td className="center">{props.client.score??(<span className='filler'></span>)}</td>
                            <td className="right">{Tools.fmtClAmmount(doc.saldo_generado)}</td>
                            <td className="center">{props.client.descPut ? (props.client.descPut +'%'):(<span className='filler'></span>)}</td>
                            <td className="center">{props.client.tipoOferta ?? (<span className='filler'></span>)}</td>
                            <td className="right">
                                {props.client.descPut ? 
                                    Tools.fmtClAmmount((doc.saldo_contable - (doc.saldo_contable * props.client.descPut) / 100).toFixed(2))
                                : 
                                    Tools.fmtClAmmount(doc.saldo_contable)
                                }
                            </td>
                        </tr>

                    );
                })}
            </tbody>
        </table>
    );

}

export default DocsRipley;